<template>
    <section class="mobile-user-page">
        <header class="mobile-user-header">
            <h1>我的</h1>
        </header>

        <main class="mobile-user-main">
            <section class="mobile-user-summary">
                <div class="mobile-user-summary__identity">
                    <img :src="avatar" alt="用户头像">
                    <div>
                        <h2>{{ displayName }}</h2>
                        <p>用户名：{{ userData.username || '—' }}</p>
                    </div>
                </div>
                <div class="mobile-user-summary__stats">
                    <div v-for="item in stats" :key="item.name">
                        <strong>{{ item.value }}</strong>
                        <span>{{ item.title }}</span>
                    </div>
                </div>
            </section>

            <section class="mobile-user-section mobile-user-profile">
                <div class="mobile-user-section__title">
                    <h2>个人信息</h2>
                    <span>账号基础资料</span>
                </div>
                <button v-for="item in profileItems" :key="item.name" class="mobile-user-profile__item" type="button" @click="openEntry(item)">
                    <span>{{ item.title }}</span>
                    <div>
                        <em>{{ item.value }}</em>
                        <b v-if="item.action">{{ item.action }}</b>
                    </div>
                </button>
            </section>

            <section class="mobile-user-section">
                <div class="mobile-user-section__title">
                    <h2>购买与权益</h2>
                </div>
                <div class="mobile-user-grid mobile-user-grid--rights">
                    <button v-for="item in rightsEntries" :key="item.name" type="button" @click="openEntry(item)">
                        <span :class="['mobile-user-entry-icon', `mobile-user-entry-icon--${item.color}`]">
                            <i :class="item.icon"></i>
                        </span>
                        <strong>{{ item.title }}</strong>
                        <small>{{ item.subtitle }}</small>
                    </button>
                </div>
            </section>

            <section class="mobile-user-section">
                <div class="mobile-user-section__title">
                    <h2>内容管理</h2>
                </div>
                <div class="mobile-user-grid mobile-user-grid--content">
                    <button v-for="item in contentEntries" :key="item.name" type="button" @click="openEntry(item)">
                        <span :class="['mobile-user-entry-icon', `mobile-user-entry-icon--${item.color}`]">
                            <i :class="item.icon"></i>
                        </span>
                        <strong>{{ item.title }}</strong>
                    </button>
                </div>
            </section>

            <button class="mobile-user-logout" type="button" @click="openLogoutDialog">退出登录</button>
            <p class="mobile-user-version">BIGEMAP 个人中心</p>
        </main>

        <mobile-account-settings
            v-model="accountDialogVisible"
            :action="accountAction"
            :user-data="userData"
            @updated="updateAccountData"
        />

    </section>
</template>

<script>
import storage from '@/utils/storage';
import MobileAccountSettings from './account-settings.vue';

const DEFAULT_AVATAR = 'https://api.bigemap.com/uploads/face/20210617/16238961269877.png';

export default {
    name: 'MobileUser',
    components: {MobileAccountSettings},
    data() {
        return {
            accountDialogVisible: false,
            accountAction: '',
            summary: {
                coin: 0,
                answer: 0,
                reply: 0,
            },
            rightsEntries: [
                {title: '我的权益', subtitle: '查看授权服务', name: 'rights', icon: 'el-icon-medal', color: 'blue'},
                {title: '我的订单', subtitle: '购买记录', name: 'orders', icon: 'el-icon-tickets', color: 'orange'},
                {title: '发票管理', subtitle: '发票与抬头', name: 'invoice', icon: 'el-icon-document', color: 'green'},
                {title: '网络版管理', subtitle: '节点与授权用户', name: 'network', icon: 'el-icon-connection', color: 'purple'},
            ],
            contentEntries: [
                {title: '我的问答', name: 'answers', icon: 'el-icon-chat-dot-square', color: 'green'},
                {title: '消息通知', name: 'messages', icon: 'el-icon-bell', color: 'orange'},
                {title: '产品圈子', name: 'products', icon: 'el-icon-box', color: 'purple'},
            ],
        };
    },
    computed: {
        userData() {
            return this.$store.state.userData || {};
        },
        avatar() {
            return this.userData.face || DEFAULT_AVATAR;
        },
        displayName() {
            return this.userData.nickname || this.userData.username || 'BIGEMAP 用户';
        },
        maskedPhone() {
            const phone = this.userData.phone;
            if (!phone) {
                return '未绑定';
            }
            return String(phone).replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2');
        },
        stats() {
            return [
                {title: '积分', name: 'coin', value: this.summary.coin},
                {title: '提问', name: 'questions', value: this.summary.answer},
                {title: '回答', name: 'answers', value: this.summary.reply},
            ];
        },
        profileItems() {
            return [
                {title: '用户名', name: 'username', value: this.userData.username || '—'},
                {title: '昵称', name: 'nickname', value: this.userData.nickname || '未设置', action: '修改'},
                {title: '手机号', name: 'phone', value: this.maskedPhone, action: this.userData.phone ? '更换' : '绑定'},
                {title: '登录密码', name: 'password', value: '已设置', action: '修改'},
            ];
        },
    },
    created() {
        this.loadSummary();
    },
    methods: {
        loadSummary() {
            this.$bbs.get('/bbs/user/ansum', {
                need: {loading: false},
            }).then((response) => {
                const data = response.data || {};
                this.summary.coin = Number(data.coin) || 0;
                this.summary.answer = Number(data.answer) || 0;
                this.summary.reply = Number(data.reply) || 0;
            }).catch(() => {});
        },
        openEntry(item) {
            const routes = {
                rights: '/user/buy/auth',
                orders: '/user/buy/list',
                invoice: '/user/buy/invoice',
                network: '/user/buy/net',
                messages: '/user/profile/message',
                answers: '/user/answer/my',
            };
            if (routes[item.name]) {
                this.$router.push({path: routes[item.name]});
                return;
            }
            if (['nickname', 'phone', 'password'].includes(item.name)) {
                this.accountAction = item.name;
                this.accountDialogVisible = true;
                return;
            }
            if (item.name === 'username') {
                return;
            }
            if (item.name === 'products') {
                this.$router.push({path: '/product'});
                return;
            }
            this.showPending(item.title);
        },
        updateAccountData(data) {
            const userData = Object.assign({}, this.userData, data);
            this.$store.dispatch('userData', userData);
        },
        showPending(title) {
            this.$message.info(`${title}功能将在下一步接入`);
        },
        openLogoutDialog() {
            this.$dialog.confirm({
                title: '退出登录',
                message: '确认退出当前账号吗？',
                confirmButtonText: '退出登录',
                cancelButtonText: '取消',
                confirmButtonColor: '#e24d4d',
                closeOnClickOverlay: true,
            }).then(() => {
                storage.clear();
                this.$store.dispatch('userData', {});
                this.$store.dispatch('permission', []);
                this.$router.replace({path: '/index'});
            }).catch(() => {});
        },
    },
};
</script>

<style scoped lang="less">
.mobile-user-page {
    min-height: 100vh;
    color: #172033;
    background:
        radial-gradient(circle at 96% 0, rgba(54, 132, 255, 0.16), transparent 26%),
        #f4f6f9;
}

.mobile-user-header {
    display: flex;
    height: 52px;
    padding: env(safe-area-inset-top) 16px 0;
    box-sizing: content-box;
    align-items: center;
    justify-content: center;

    h1 {
        margin: 0;
        font-size: 17px;
        font-weight: 600;
        text-align: center;
    }
}

.mobile-user-main {
    padding: 4px 12px 26px;
}

.mobile-user-summary,
.mobile-user-section {
    overflow: hidden;
    background: #fff;
    border: 1px solid rgba(225, 230, 238, 0.82);
    border-radius: 15px;
    box-shadow: 0 8px 24px rgba(31, 52, 80, 0.045);
}

.mobile-user-summary {
    background:
        linear-gradient(135deg, rgba(237, 245, 255, 0.96), rgba(255, 255, 255, 0.98) 58%),
        #fff;
}

.mobile-user-summary__identity {
    display: flex;
    padding: 20px 16px 18px;
    align-items: center;

    img {
        width: 58px;
        height: 58px;
        flex: 0 0 58px;
        object-fit: cover;
        background: #eef2f7;
        border: 3px solid #fff;
        border-radius: 50%;
        box-shadow: 0 4px 14px rgba(42, 91, 156, 0.16);
    }

    div {
        min-width: 0;
        padding-left: 13px;
        flex: 1;
    }

    h2 {
        overflow: hidden;
        margin: 0 0 6px;
        font-size: 19px;
        font-weight: 650;
        line-height: 1.25;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    p {
        overflow: hidden;
        margin: 0;
        color: #7c8799;
        font-size: 12px;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

}

.mobile-user-summary__stats {
    display: grid;
    margin: 0 13px;
    padding: 13px 0 15px;
    grid-template-columns: repeat(3, 1fr);
    border-top: 1px solid #edf0f5;

    > div {
        position: relative;
        display: flex;
        padding: 0;
        flex-direction: column;
        align-items: center;
        color: inherit;
        background: transparent;
        border: 0;

        & + div::before {
            position: absolute;
            top: 7px;
            bottom: 7px;
            left: 0;
            width: 1px;
            content: '';
            background: #edf0f5;
        }
    }

    strong {
        font-size: 18px;
        font-weight: 650;
        line-height: 24px;
    }

    span {
        margin-top: 2px;
        color: #7f8a9b;
        font-size: 12px;
    }
}

.mobile-user-section {
    margin-top: 12px;
}

.mobile-user-section__title {
    display: flex;
    min-height: 48px;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;

    h2 {
        margin: 0;
        font-size: 15px;
        font-weight: 650;
    }

    span {
        color: #a0a9b7;
        font-size: 11px;
    }
}

.mobile-user-profile__item {
    display: flex;
    width: 100%;
    min-height: 49px;
    padding: 0 15px;
    align-items: center;
    justify-content: space-between;
    color: #313d50;
    font-size: 14px;
    text-align: left;
    background: #fff;
    border: 0;
    border-top: 1px solid #f0f2f6;

    > div {
        display: flex;
        min-width: 0;
        padding-left: 16px;
        align-items: center;
    }

    em {
        overflow: hidden;
        max-width: 150px;
        color: #8994a6;
        font-size: 13px;
        font-style: normal;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    b {
        margin-left: 9px;
        color: #2478f2;
        font-size: 12px;
        font-weight: 500;
    }

}

.mobile-user-grid {
    display: grid;
    padding: 3px 8px 14px;
    grid-template-columns: repeat(4, 1fr);

    button {
        display: flex;
        min-width: 0;
        padding: 8px 2px 4px;
        flex-direction: column;
        align-items: center;
        color: #394559;
        background: transparent;
        border: 0;
    }

    strong {
        margin-top: 7px;
        font-size: 12px;
        font-weight: 500;
        white-space: nowrap;
    }

    small {
        margin-top: 4px;
        color: #a1a9b6;
        font-size: 10px;
        white-space: nowrap;
    }
}

.mobile-user-grid--rights {
    padding-bottom: 16px;

    button {
        padding-right: 0;
        padding-left: 0;
    }
}

.mobile-user-grid--content {
    grid-template-columns: repeat(3, 1fr);
}

.mobile-user-entry-icon {
    display: flex;
    width: 38px;
    height: 38px;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    border-radius: 12px;
}

.mobile-user-entry-icon--blue {
    color: #2478f2;
    background: #eaf2ff;
}

.mobile-user-entry-icon--green {
    color: #23a875;
    background: #e7f7f1;
}

.mobile-user-entry-icon--orange {
    color: #ec8a28;
    background: #fff2e4;
}

.mobile-user-entry-icon--purple {
    color: #8066da;
    background: #f0ecff;
}

.mobile-user-logout {
    width: 100%;
    height: 48px;
    margin-top: 12px;
    color: #e24d4d;
    font-size: 14px;
    font-weight: 500;
    background: #fff;
    border: 1px solid rgba(225, 230, 238, 0.82);
    border-radius: 14px;
}

.mobile-user-version {
    margin: 15px 0 0;
    color: #b0b7c2;
    font-size: 11px;
    text-align: center;
}

@media (max-width: 350px) {
    .mobile-user-grid small {
        display: none;
    }

    .mobile-user-profile__item em {
        max-width: 118px;
    }
}
</style>
